/**
 * 个人微信面板 —— 首页「联系」和 /support 共用同一块。
 *
 * 两处必须长得一模一样：从页脚点进支持页，看到的联系方式如果换了个版式，
 * 客户第一反应是「这是不是两个人」。所以码、读数、行距都在这里定，两边只传标题。
 *
 * 二维码素材由 scripts/build-wechat-qr.py 从微信导出图裁出并换成站点配色
 * （骨白底 / 深墨码，对比度约 17:1，极性没变，不影响扫码）。换码时重跑那个脚本，
 * 别直接把微信的白底分享图丢进来。
 */

export const WECHAT_ID = 'YangZaiAITech';
export const EMAIL = 'contact@aiislove.tech';

const readouts: [string, string, string][] = [
  ['微信', 'WECHAT', WECHAT_ID],
  ['邮箱', 'EMAIL', EMAIL],
  ['回复', 'REPLY', '工作日一天内'],
];

export default function ContactPanel({
  title = '加我的微信',
  note = '扫不了码就搜微信号，或者直接发邮件——三条路通到同阳仔AI，没有客服中转。',
}: {
  title?: string;
  note?: string;
}) {
  return (
    <div className="overflow-hidden rounded-[10px] border border-rack-amber/25 bg-rack-panel">
      <div className="flex items-center justify-between gap-3 border-b border-rack-bone/[0.08] bg-rack-chrome px-5 py-3">
        <span className="text-[13px] font-medium text-rack-bone/90">{title}</span>
        <span className="font-readout text-[9.5px] uppercase tracking-[0.16em] text-rack-amber/70">
          个人号 · 本人回复
        </span>
      </div>

      <div className="grid gap-8 p-6 sm:p-8 lg:grid-cols-[200px_1fr] lg:items-center">
        <figure className="m-0">
          <img
            src="/social/wechat-personal.png"
            alt="阳仔AI 个人微信二维码"
            width={200}
            height={200}
            loading="lazy"
            className="h-[172px] w-[172px] rounded-[6px] border border-rack-bone/12 bg-rack-bone/[0.04] object-contain p-2 sm:h-[200px] sm:w-[200px]"
          />
          <figcaption className="mt-3 font-readout text-[9.5px] uppercase tracking-[0.16em] text-rack-bone/26">
            SCAN TO ADD
          </figcaption>
        </figure>

        <div>
          <dl className="border-t border-rack-bone/10">
            {readouts.map(([k, en, v]) => (
              <div
                key={k}
                className="flex flex-wrap items-baseline gap-x-5 gap-y-1 border-b border-rack-bone/[0.07] py-3"
              >
                <dt className="flex w-[92px] shrink-0 items-baseline gap-2">
                  <span className="text-[12px] text-rack-bone/55">{k}</span>
                  <span className="font-readout text-[9px] uppercase tracking-[0.14em] text-rack-bone/22">
                    {en}
                  </span>
                </dt>
                <dd className="font-readout text-[14.5px] tracking-[0.05em] text-rack-bone/90">
                  {v === EMAIL ? (
                    <a
                      href={`mailto:${EMAIL}`}
                      className="border-b border-rack-amber/30 pb-0.5 text-rack-amber transition-colors hover:border-rack-amber focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-rack-amber"
                    >
                      {v}
                    </a>
                  ) : (
                    v
                  )}
                </dd>
              </div>
            ))}
          </dl>
          <p className="mt-5 max-w-[46ch] text-[12.5px] leading-[1.9] text-rack-bone/42">{note}</p>
        </div>
      </div>
    </div>
  );
}
